import { Component } from '@angular/core';

import { CheckoutService } from '../../../../../../checkout/checkout.service';

@Component({
    selector: 'app-product-summary',
    template: `
        <section class="summary summary--active" *ngIf="checkoutService.getCheckoutData() | async as cd" appCircleCheckmark [condition]="true">
            <div class="summary__header">
                <h3 class="h5 no-margin">
                    {{ 'checkout.summary_step____product_section____headline' | translate }}
                </h3>
            </div>
            <div class="summary__content text-small">
                <div class="unstyled-table unstyled-table--first-child-bold" role="table">
                    <div class="unstyled-table__row" role="row">
                        <div class="unstyled-table__cell" role="cell">{{ 'checkout.summary_step____product_section____model' | translate }}</div>
                        <div class="unstyled-table__cell" role="cell">{{ cd.product?.name }}</div>
                    </div>
                    <div class="unstyled-table__row" role="row">
                        <div class="unstyled-table__cell" role="cell">{{ 'checkout.summary_step____product_section____mileage' | translate }}</div>
                        <div class="unstyled-table__cell" role="cell">{{ cd.product?.mileage | number }}</div>
                    </div>
                    <div class="unstyled-table__row" role="row">
                        <div class="unstyled-table__cell" role="cell">{{ 'checkout.summary_step____product_section____year' | translate }}</div>
                        <div class="unstyled-table__cell" role="cell">{{ cd.product?.year }}</div>
                    </div>
                </div>
            </div>
        </section>
    `,
})
export class ProductSummaryComponent {
    constructor(public checkoutService: CheckoutService) {}
}
